// extracted by mini-css-extract-plugin
module.exports = {"tag":"TagWrapper_tag__1rXhx"};